import Cookies from "js-cookie";

const BRIDGE_DATA_KEY = "bridgeData";
const SHARED_DATA_COOKIE_KEY = "sharedData";

const DEV_FALLBACK = {
  phoneNumber: "9717128773",
  cardSerNo: "39790",
  deviceId: "4223",
  superMoneyAccountId: "ifnfjjd",
  last4Digits: "0474",
  preventScreenCapture: false,
  bank: "axis"
};

function flattenSharedDataPayload(data) {
  if (!data || typeof data !== "object") {
    return null;
  }

  if (!data.userDetails || typeof data.userDetails !== "object") {
    return data;
  }

  const { userDetails, ...topLevel } = data;
  return { ...userDetails, ...topLevel };
}

export function normalizeBridgeData(data) {
  if (!data || typeof data !== "object") {
    return null;
  }

  return {
    superMoneyAccountId: data.superMoneyAccountId ?? "",
    phoneNumber: data.phoneNumber ?? "",
    cardSerNo: String(data.cardSer ?? data.cardSerNo ?? ""),
    deviceId: String(data.deviceid ?? data.deviceId ?? ""),
    last4Digits: String(data.last4Digits ?? ""),
    preventScreenCapture: Boolean(data.preventScreenCapture),
    bank: data.bank ?? ""
  };
}

export function parseBridgeData(raw) {
  if (!raw || raw === "undefined") {
    return null;
  }

  try {
    return normalizeBridgeData(flattenSharedDataPayload(JSON.parse(raw)));
  } catch {
    return null;
  }
}

function readBridgeDataRaw() {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }

  return window.localStorage.getItem(BRIDGE_DATA_KEY); // window. is required guard for non browser environments
}

function readSharedDataCookieRaw() {
  return Cookies.get(SHARED_DATA_COOKIE_KEY) ?? null;
}

export function getBridgeData() {
  const fromCookie = parseBridgeData(readSharedDataCookieRaw());
  // top priority is cookie
  if (fromCookie) {
    return fromCookie;
  }

  // second priority is local storage
  const fromStorage = parseBridgeData(readBridgeDataRaw());
  if (fromStorage) {
    return fromStorage;
  }

  // third priority is development fallback
  if (process.env.NODE_ENV === "development") {
    return normalizeBridgeData(DEV_FALLBACK);
  }

  return null;
}

function toUserDetails(bridge) {
  if (!bridge) {
    return null;
  }

  return {
    phoneNumber: bridge.phoneNumber,
    cardSerNo: bridge.cardSerNo,
    deviceId: bridge.deviceId,
    superMoneyAccountId: bridge.superMoneyAccountId,
    last4Digits: bridge.last4Digits
  };
}

export function getUserDetailsFromBridge(bridgeData) {
  return toUserDetails(bridgeData ?? getBridgeData());
}

export function getOtpIdentityParams({ userDetails = {}, bridgeData } = {}) {
  const bridge = getUserDetailsFromBridge(bridgeData);

  return {
    cardSerNo: bridge?.cardSerNo || userDetails.cardSerNo || "",
    deviceId: bridge?.deviceId || userDetails.deviceId || ""
  };
}
